/**
 * "+" quick-add button on BabyBjörn product cards.
 * Adds the card's variant to the cart via the AJAX API and re-renders the cart
 * drawer, without a <form> (cards can sit inside the cart drawer's own form).
 */
if (!customElements.get('bb-quick-add')) {
  customElements.define(
    'bb-quick-add',
    class BbQuickAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        event.preventDefault();
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const spinner = this.querySelector('.loading__spinner');

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');

        const body = { items: [{ id: Number(this.dataset.variantId), quantity: 1 }] };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'bb-quick-add',
                productVariantId: this.dataset.variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'bb-quick-add',
              productVariantId: this.dataset.variantId,
              cartData: response,
            });
            // renderContents expects the line item (for productId) plus sections.
            const item = (response.items && response.items[0]) || {};
            cart.renderContents({ ...item, sections: response.sections });
          })
          .catch((error) => console.error(error))
          .finally(() => {
            // The drawer re-render usually replaces this element; reset in case it didn't.
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
